// @flow

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import colorUtils from 'color';
import useSheet from '../../jss';
import Spinner from './Spinner';

const propTypes = {
  message: PropTypes.string,
  sheet: PropTypes.object.isRequired,
  showSpinner: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small', 'large']),
  title: PropTypes.string,
};

const defaultProps = {
  message: '',
  showSpinner: false,
  size: 'default',
  title: '',
};

function EmptyStateBox({ message, sheet: { classes }, showSpinner, size, title }) {
  return (
    <div className={classNames(classes.emptyBox, classes[size])}>
      {showSpinner ? (
        <Spinner />
      ) : (
        <div>
          <div className={classes.emptyBox_Title}>{title}</div>
          <div className={classes.emptyBox_Message}>{message}</div>
        </div>
      )}
    </div>
  );
}

EmptyStateBox.propTypes = propTypes;
EmptyStateBox.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    emptyBox: {
      alignItems: 'center',
      // backgroundColor: theme.color.basis3,
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      textTransform: 'uppercase',
    },
    default: {
      padding: `${theme.spacing.xlarge * 2}px 0`,
      borderRadius: theme.borderRadius.large,
    },
    small: {
      padding: `${theme.spacing.large}px 0`,
    },
    large: {
      padding: `${theme.spacing.xlarge * 4}px 0`,
      borderRadius: theme.borderRadius.large,
    },
    emptyBox_Title: {
      color: theme.color.basis4,
      fontWeight: theme.fontWeight.demiBold,
      fontSize: theme.fontSize.large,
      textAlign: 'center',
    },
    emptyBox_Message: {
      color: theme.color.basis4,
      textAlign: 'center',
    },
  };
}

export default useSheet(applyStyles)(EmptyStateBox);
